import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { Input, TextField, Label } from 'wix-style-react'
import TextLink from 'wix-style-react/src/TextLink'
import * as _ from 'lodash'

// import { BLUE } from '../styles'
import { IA_HOST_NAME } from 'constants/index'
import { isAppNameUnique } from 'controllers/logic'

// const UrlText = styled.div`
//   color: ${BLUE};
//   display: flex;
//   align-items: center;
//   justify-content: flex-start;
//   font-size: 85%;
// `
const AppNameLabelContainer = styled.div`
  display: flex;
  justify-content: space-between;
`
const Prefix = styled.div`
  margin-left: 10px;
`

class AppNameInput extends Component {

  constructor (props) {
    super(props)

    this.state = {
      appName: props.appName,
      isValid: false,
      errorMessage: null
    }
  }

  componentDidMount () {
    this.checkAppName(this.state.appName)
  }

  onNameChange = (e) => {
    const appName = e.target.value
      .replace(/[\W]+/g, '_')
      .replace(/^(ia)/, 'ai')

    if (appName === '') {
      this.setState({ isValid: false, errorMessage: 'The app name can not be empty' })
      this.checkAppName.cancel()
      this.props.onChangeAppName('')
    } else {
      this.checkAppName(appName)
    }

    this.setState({ appName })
  }

  checkAppName = _.throttle(async (appName) => {
    const result = await isAppNameUnique(appName)
    if (result) {
      this.setState({ isValid: true, errorMessage: '' })
      this.props.onChangeAppName(appName)
    } else {
      this.props.onChangeAppName('')
      this.setState({ isValid: false, errorMessage: 'The app name is busy, please choose another one' })
    }
  }, 250)

  renderPrefix = () => {
    const { prefix } = this.props
    if (prefix) {
      return (
        <Prefix>
          {prefix}
        </Prefix>
      )
    }
  }

  renderAppLink = () => {
    const { showLink } = this.props
    const { appName } = this.state
    if (appName && showLink) {
      const url = `${IA_HOST_NAME}/${appName}`
      return (
        <TextLink link={url} target={'_blank'}>
          {url}
        </TextLink>
      )
    }
  }

  render () {
    const { title, required } = this.props
    const { appName, isValid, errorMessage } = this.state
    return (
      <TextField required={required}>
        <Label>
          <AppNameLabelContainer>
            {title}
            {this.renderAppLink()}

          </AppNameLabelContainer>
        </Label>

        <Input
          placeholder='Enter app name'
          onChange={this.onNameChange}
          value={appName}
          maxLength={30}
          autoFocus
          error={!isValid && !_.isNil(errorMessage)}
          errorMessage={errorMessage}
          prefix={this.renderPrefix()}
        />
      </TextField>
    )
  }
}

AppNameInput.defaultProps = {
  appName: '',
  required: true,
  title: 'Your Whimm app name',
  showLink: true
}

AppNameInput.propTypes = {
  onChangeAppName: PropTypes.func.isRequired,
  appName: PropTypes.string,
  required: PropTypes.bool,
  title: PropTypes.string,
  showLink: PropTypes.bool,
  prefix: PropTypes.string
}

export default connect()(AppNameInput)



// WEBPACK FOOTER //
// ./src/components/shared/AppNameInput.js